import React, { useEffect, useRef } from 'react';
import './StartSplash.css';

const StartSplash = ({ onContinue, onOpenTerms }) => {
  const btnRef = useRef(null);

  useEffect(() => {
    // Auto-scroll to hide address bar on mobile browsers
    const hideAddressBar = () => {
      setTimeout(() => {
        window.scrollTo(0, 1);
      }, 100);
    };
    hideAddressBar();
    window.addEventListener('orientationchange', hideAddressBar);
    
    const btn = btnRef.current;
    if (!btn) return;
    btn.disabled = true;
    const timer = setTimeout(() => {
      btn.disabled = false;
      btn.style.background = 'linear-gradient(90deg, #15335B 0%, #286ECC 100%)';
      btn.style.cursor = 'pointer';
    }, 1000);
    
    return () => {
      clearTimeout(timer);
      window.removeEventListener('orientationchange', hideAddressBar);
    };
  }, []);

  // hVerifySDK is now initialized in App.js to persist throughout the app

  return (
    <div className="container">
      <div className="top-section">
        <div className="logo">
          <img src={require('./logo.png')} alt="hVerify Logo" style={{width: 105, height: 40, display: 'block', margin: '0 auto'}} />
        </div>
        <h1 className="title">Altersverifikation</h1>
        <div className="subtitle">Alter verifizieren in weniger als 30 Sekunden.</div>
        <div className="progress-bar">
          <div className="progress-bar-inner"></div>
        </div>
      </div>
      <div className="bottom-section">
        <div className="terms">
          Wenn Sie fortfahren stimmen Sie den{' '}
          <button type="button" className="terms-link" onClick={e => {e.preventDefault(); onOpenTerms && onOpenTerms();}}>
            Nutzungsbestimmungen
          </button>{' '}
          von hVerify zu.<br /><br />hVerify speichert keine persönlichen Daten.
        </div>
        <button className="weiter-btn" ref={btnRef} onClick={() => btnRef.current && !btnRef.current.disabled && onContinue && onContinue()}>
          Weiter
        </button>
      </div>
    </div>
  );
};

export default StartSplash;
